'use strict';

var blacklist = [
	'freelist',
	'sys'
];

module.exports = Object.keys(process.binding('natives')).filter(function (el) {
	return !/^_|^internal|\//.test(el) && blacklist.indexOf(el) === -1;
}).sort();



//////////////////
// WEBPACK FOOTER
// ./node_modules/builtin-modules/index.js
// module id = 229
// module chunks = 0